import { render } from "./Test2.vue?vue&type=template&id=2658cd10"
import script from "./Test2.vue?vue&type=script&lang=js"
export * from "./Test2.vue?vue&type=script&lang=js"
script.render = render

export default script